import { Backdrop, Box, CircularProgress } from "@mui/material";
import React from "react";
import Form from "./Form";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getGroupStatus, getPeriods, getUserCountries } from "./cgpgSlice";
import ProductGroupsTable from "./ProductGroupsTable";
import CustomerGroupsTable from "./CustomerGroupsTable";
import ButtonGroup from "./ButtonGroup";
import RejectSelectedModal from "./RejectSelectedModal";
import Comments from "./Comments";

export default function CGPG() {
   const dispatch = useDispatch();
   const states = useSelector((store) => store.cgpgApproval);
   const {
      isLoading,
      countries,
      groupStatusList,
      periods,
      productGroupsTable,
      customerGroupsTable,
   } = states;

   useEffect(() => {
      if (countries.length === 0) {
         dispatch(getUserCountries());
      }
      if (groupStatusList.length === 0) {
         dispatch(getGroupStatus());
      }
      if (periods.length === 0) {
         dispatch(getPeriods());
      }
   }, []);

   return (
      <Box>
         <Box>
            <Backdrop
               sx={{
                  color: "#fff",
                  zIndex: (theme) => theme.zIndex.drawer + 1,
               }}
               open={isLoading}
            >
               <CircularProgress />
            </Backdrop>
         </Box>
         <Form />
         {productGroupsTable !== null ? <ProductGroupsTable /> : null}
         {customerGroupsTable !== null ? <CustomerGroupsTable /> : null}
         <ButtonGroup/>
         <RejectSelectedModal/>
         <Comments/>
      </Box>
   );
}
